import React from "react";
import classes from "./OrderDatesSummary.module.scss";
import { ORDER_DATE_FIELDS } from "../../functions/order/orderDateUpdate";
import { formatOrderDate } from "../../functions/utils/formatting";

// 注文1明細の4日付(注文日・発注日・検収日・取消日)を表示する共通コンポーネント。
//
// 日付はカート(order_id)単位ではなく明細(order_number)単位で持っているため、
// 注文履歴のカード・発注処理の注文詳細ダイアログ・ステータス変更の確認ダイアログの
// いずれでも「その明細の日付」として同じ見た目で出す。
//
// layout:
//   "grid" … 2列(モバイルは1列)。明細カード内の表示用
//   "rows" … ラベル左・値右の1行ずつ。ダイアログ内の表示用
const OrderDatesSummary = ({ order, layout = "grid", title }) => {
  if (!order) return null;
  return (
    <div className={classes.root}>
      {title && <div className={classes.title}>{title}</div>}
      <div className={layout === "rows" ? classes.rows : classes.grid}>
        {ORDER_DATE_FIELDS.map(({ field, label }) => (
          <div key={field} className={classes.item}>
            <span className={classes.label}>{label}</span>
            <span
              className={`${classes.value} ${
                order[field] ? "" : classes.empty
              }`}
            >
              {formatOrderDate(order[field])}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderDatesSummary;
